import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import {
    FormGroupType,
    NestedFormGroupType,
} from '../../../../../core/models/form-group-type';
import { RegExPattern } from '../../../../../core/models/regexp-pattern/regex-pattern';
import { OrderConstants } from '../../shared/constants/order-constants';
import { OrderStatus } from '../../shared/constants/order-status';
import { OrderDetailsConstants } from '../constants/order-details-constants';
import { OrderDetailsFormModel } from '../models/order-details-form-model';
import { OrderLineItemFormModel } from '../models/order-line-item-form-model';

@Injectable({
    providedIn: 'root',
})
export class OrderDetailsFormService {
    getFormDefinition(): FormGroup<NestedFormGroupType<OrderDetailsFormModel>> {
        return new FormGroup<NestedFormGroupType<OrderDetailsFormModel>>({
            status: new FormControl<OrderStatus | null>(
                null,
                Validators.required,
            ),
            notes: new FormControl<string | null>(null, [
                Validators.maxLength(OrderDetailsConstants.MAX_NOTES_LENGTH),
                Validators.pattern(
                    RegExPattern.PrintableAsciiExceptAngleBracketsAndPipes,
                ),
            ]),
            poNumber: new FormControl<string | null>(null, [
                Validators.maxLength(OrderConstants.MAX_PO_NUMBER_LENGTH),
                Validators.pattern(
                    RegExPattern.PrintableAsciiExceptAngleBracketsAndPipes,
                ),
            ]),
            orderLineItems: new FormArray<
                FormGroup<FormGroupType<OrderLineItemFormModel>>
            >([], {
                validators: [Validators.required],
            }),
        });
    }

    /**
     * Resets the order details form to its initial state.
     *
     * @param form The order details form group to reset.
     */
    resetForm(
        form: FormGroup<NestedFormGroupType<OrderDetailsFormModel>>,
    ): void {
        // Reset the form controls from the form group
        form.reset({}, { emitEvent: false });

        const orderLineItemsFormArray = form.controls
            .orderLineItems as FormArray;
        orderLineItemsFormArray.clear();
    }
}
